import React, { ReactElement, useEffect, useState } from 'react';
import getHomeUrl from '../utils/getHomeUrl';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

const ErrorMessage = ({ message, onRetry }: ErrorMessageProps): ReactElement => {
  const [homeUrl, setHomeUrl] = useState<string | null>(null);
  const [loadingHomeUrl, setLoadingHomeUrl] = useState(true);

  useEffect(() => {
    getHomeUrl()
      .then((response) => {
        setHomeUrl(response.homeUrl);
        setLoadingHomeUrl(false);
      })
      .catch((error) => {
        console.error('Failed to fetch home URL:', error);
        setLoadingHomeUrl(false);
      });
  }, []);

  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
      textAlign: 'center',
      backgroundColor: '#fafafa', // --background
      padding: '20px',
      boxSizing: 'border-box'
    }}>
      <div style={{
        backgroundColor: '#ffffff', // --card
        borderRadius: '0.625rem', // --radius
        padding: '40px',
        maxWidth: '600px',
        width: '100%',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        border: '1px solid #d4dcba' // --border
      }}>
        {/* Error Icon */}
        <div style={{
          width: '65px',
          height: '55px',
          borderRadius: '50%',
          backgroundColor: '#fef2f2', // --destructive-foreground (light red background)
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '32px',
          paddingBottom: '10px'
        }}>
          ⚠️
        </div>

        {/* Error Message */}
        <div style={{
          color: '#b23d3d', // --destructive
          fontWeight: '600',
          fontSize: '20px',
          lineHeight: '1.5',
          textAlign: 'center'
        }}>
          {message}
        </div>

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          width: '100%',
          maxWidth: '300px'
        }}>
          {onRetry && (
            <button
              onClick={onRetry}
              style={{
                fontFamily: 'inherit',
                padding: '12px 24px',
                fontSize: '16px',
                backgroundColor: '#6b8f2a', // --primary
                color: '#f1f6e2', // --primary-foreground
                border: 'none',
                borderRadius: '0.625rem', // --radius
                cursor: 'pointer',
                fontWeight: '500',
                transition: 'background-color 0.2s',
                width: '100%'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#5a7a24'; // Darker primary
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#6b8f2a'; // --primary
              }}
            >
              Retry
            </button>
          )}

          {!loadingHomeUrl && homeUrl && (
            <a
              href={homeUrl}
              style={{
                fontFamily: 'inherit',
                padding: '12px 24px',
                fontSize: '16px',
                backgroundColor: '#cdd8a7', // --secondary
                color: '#2f321c', // --secondary-foreground
                border: 'none',
                borderRadius: '0.625rem', // --radius
                cursor: 'pointer',
                fontWeight: '500',
                textDecoration: 'none',
                textAlign: 'center',
                display: 'block',
                transition: 'background-color 0.2s',
                width: '100%',
                boxSizing: 'border-box'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#b8c894'; // Darker secondary
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#cdd8a7'; // --secondary
              }}
            >
              Go to Home
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;

